import React from 'react';

const PoliticaPrivacidad = () => {
  return (
    <div className="container" style={{ padding: '3rem 0' }}>
      <h1>Política de Privacidad</h1>
      
      <h2>1. Responsable del Tratamiento</h2>
      <p><strong>Identidad:</strong> [TU NOMBRE]</p>
      <p><strong>NIF:</strong> [TU NIF]</p>
      <p><strong>Dirección:</strong> C/MAYOR 17, 08389 PALAFOLLS, BARCELONA</p>
      <p><strong>Email:</strong> [TU EMAIL]</p>
      
      <h2>2. ¿Qué datos recogemos?</h2>
      <p>A través de nuestro formulario de contacto, recogemos:</p>
      <ul>
        <li>Nombre completo</li>
        <li>Dirección de correo electrónico</li>
        <li>Número de teléfono</li>
        <li>Mensaje que nos envías</li>
      </ul>
      
      <h2>3. Finalidad del tratamiento</h2>
      <p>Tus datos serán utilizados para:</p>
      <ul>
        <li>Responder a tus consultas y solicitudes de presupuesto</li>
        <li>Gestionar la relación comercial contigo</li>
        <li>Envío de información que nos solicites</li>
      </ul>
      
      <h2>4. Base legal</h2>
      <p>El tratamiento de tus datos se basa en tu consentimiento al rellenar el formulario de contacto.</p>
      
      <h2>5. Plazo de conservación</h2>
      <p>Conservaremos tus datos mientras sea necesarios para responder a tu consulta y durante el plazo legalmente establecido.</p>
      
      <h2>6. Cesión de datos</h2>
      <p>No cedemos tus datos a terceros, salvo obligación legal.</p>
      
      <h2>7. Tus derechos</h2>
      <p>Tienes derecho a:</p>
      <ul>
        <li><strong>Acceder</strong> a tus datos</li>
        <li><strong>Rectificarlos</strong> si son incorrectos</li>
        <li><strong>Suprimirlos</strong> (derecho al olvido)</li>
        <li><strong>Oponerte</strong> al tratamiento</li>
        <li><strong>Limitar</strong> el tratamiento</li>
        <li><strong>Portabilidad</strong> de tus datos</li>
      </ul>
      <p>Para ejercer tus derechos, escríbenos a: [TU EMAIL]</p>
      
      <h2>8. Derecho a reclamar</h2>
      <p>Si consideras que no tratamos tus datos correctamente, puedes reclamar ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong>.</p>
    </div>
  );
};

export default PoliticaPrivacidad;